import React, { useEffect, useLayoutEffect } from 'react';
function useIsomorphicLayoutEffect(callback, deps) {
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}
export { useIsomorphicLayoutEffect };